export enum CardiacConstants {
  SET_ACTION = 'cardiac/SET_ACTION',
  SET_DATE_TIME = 'cardiac/SET_DATE_TIME',
  SET_PTA = 'cardiac/SET_PTA',
  SET_ASSESSED_BY = 'cardiac/SET_ASSESSED_BY',
  SET_SUCCESSFUL_ATTEMPT = 'cardiac/SET_SUCCESSFUL_ATTEMPT',
  SET_PROCEDURE_COMPLICATIONS = 'cardiac/SET_PROCEDURE_COMPLICATIONS',
  SET_RESPONSE = 'cardiac/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'cardiac/SET_RESPONSE_PNNV',
  SET_AUTHORIZATION = 'cardiac/SET_AUTHORIZATION',
  SET_COMMENTS = 'cardiac/SET_COMMENTS',
  SET_LEAD_CHANGE = 'cardiac/SET_LEAD_CHANGE',
  SET_JOULES = 'cardiac/SET_JOULES',
  SET_DEFIB_TYPE = 'cardiac/SET_DEFIB_TYPE',
  SET_TYPE = 'cardiac/SET_TYPE',
  SAVE_CARDIAC = 'cardiac/SAVE_CARDIAC',
  SET_ADD_TO_TIMELINE = 'cardiac/SET_ADD_TO_TIMELINE',
  RESET_STATE = 'cardiac/RESET_STATE',
  RESET_TO_INITIAL_STATE = 'cardiac/RESET_TO_INITIAL_STATE',
  SET_UPDATE_INPUT_ROWS = 'cardiac/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'cardiac/SET_DATE',
  SET_TIME = 'cardiac/SET_TIME',
  SET_STATE = 'cardiac/SET_STATE',
  ON_SELECT_CARDIAC = 'cardiac/ON_SELECT_CARDIAC',
  SET_ATTEMPTS = 'cardiac/SET_ATTEMPTS',
  SET_SAVE_RESPONSE = 'cardiac/SET_SAVE_RESPONSE',
  SET_ROLE_PERFORMING = 'cardiac/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'cardiac/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'cardiac/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'cardiac/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_MA = 'cardiac/SET_MA',
  SET_HEART_RATE = 'cardiac/SET_HEART_RATE',
  SET_PACING_MODE = 'cardiac/SET_PACING_MODE',
  SET_COMPRESSION_RATE = 'cardiac/SET_COMPRESSION_RATE',
  SET_LOCATION = 'cardiac/SET_LOCATION',
  SET_MECHANICAL_CPR_TYPE = 'cardiac/SET_MECHANICAL_CPR_TYPE',
  SET_CARDIAC_DEFAULTS = 'cardiac/SET_CARDIAC_DEFAULTS',
}
